import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { SFPalette } from '@/lib/color';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { fontWeight, inter } from '@/theme';
import Chip from '@mui/material/Chip';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import { users, userInfoResProps } from '@/api/server/user/read';
import ErrorRes from '@/api/server/ErrorRes';
import { toast } from 'react-toastify';
import { maskingName, maskingEmail } from '@/lib/Masking';
import { useTranslation } from 'react-i18next';
function AuthLevelLabel({ children, status }: { children: React.ReactNode; status: '완료' | '미완료' }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h6" fontWeight={700}>
        {children}
      </Typography>
      <Chip
        label={status}
        color={status === '완료' ? 'primary' : 'default'}
        sx={{
          fontWeight: fontWeight.Bold,
        }}
      />
    </Stack>
  );
}

export default function WalletAuthLevelPage() {
  // 언어 변경 해야 함
  const { t } = useTranslation();
  const [user, setUser] = useState<userInfoResProps | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      const re = await users();
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg, path: 'authLevel' });
      }
      setUser(re.data);
    })();
    return () => {};
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title={t('title.authLevel')}
        backPath="/my"
        boxProps={{
          mb: 4,
        }}
      />
      <Box>
        ※ {t('message.onlyShuffleUser')}
        <Typography variant="h4">
          <strong>{user?.real_name ? maskingName(user.real_name) : maskingEmail(user?.email)}</strong> 님은
          <br />
          현재{' '}
          <Box component="span" fontWeight={fontWeight.Bold} color={SFPalette.shuffleColor}>
            레벨{user?.auth_lv_num}
          </Box>
          입니다.
        </Typography>
      </Box>
      <Divider sx={{ my: 3.5 }} />
      <Box>
        <Box mb={1.5}>
          {Number(user?.auth_lv_num) >= 1 ? (
            <AuthLevelLabel status="완료">Lv.1 계정 인증</AuthLevelLabel>
          ) : (
            <AuthLevelLabel status="미완료">Lv.1 계정 인증</AuthLevelLabel>
          )}
        </Box>
        <Stack direction="row" columnGap={1.5} alignItems="center" mb={1}>
          {user?.mobile ? (
            <>
              <Chip
                label="핸드폰"
                sx={{
                  border: `1px solid ${SFPalette.lightGrey1}`,
                  bgcolor: 'white',
                  color: SFPalette.grey2,
                  fontWeight: fontWeight.Medium,
                }}
              />
              <Typography variant="body2" color={SFPalette.grey2} fontFamily={inter.style.fontFamily}>
                {maskingName(user?.mobile)}
              </Typography>
            </>
          ) : (
            ''
          )}
        </Stack>
        <Stack direction="row" columnGap={1.5} alignItems="center">
          <Chip
            label="이메일"
            sx={{
              border: `1px solid ${SFPalette.lightGrey1}`,
              bgcolor: 'white',
              color: SFPalette.grey2,
              fontWeight: fontWeight.Medium,
            }}
          />
          <Typography variant="body2" color={SFPalette.grey2} fontFamily={inter.style.fontFamily}>
            {maskingEmail(user?.email)}
          </Typography>
        </Stack>
      </Box>
      <Divider sx={{ my: 3.5 }} />
      <Box>
        <Box mb={1.5}>
          {Number(user?.auth_lv_num) >= 2 ? (
            <AuthLevelLabel status="완료">Lv.2 보안 PIN 번호 설정</AuthLevelLabel>
          ) : (
            <AuthLevelLabel status="미완료">Lv.2 보안 PIN 번호 설정</AuthLevelLabel>
          )}

          <ArrowLinkButton
            typographyProps={{
              sx: {
                color: SFPalette.grey2,
              },
            }}
            onClick={() => {
              // navigate('/pinCheck');
              navigate('/pinComponent', {
                state: {
                  pinType: 'check',
                  title: 'PIN 번호 확인',
                  returnUrl: '/authLevel',
                  options: {
                    email: user?.email,
                    check: 'authLevel'
                  },
                },
              });
            }}
          >
            PIN 번호 설정
          </ArrowLinkButton>
        </Box>
      </Box>
      <Divider sx={{ my: 3.5 }} />
      <Box>
        <Box mb={1.5}>
          {/* {Number(user?.auth_lv_num) >= 3 ? (
            <AuthLevelLabel status="완료">Lv.3 실명 인증</AuthLevelLabel>
          ) : (
            <AuthLevelLabel status="미완료">Lv.3 실명 인증</AuthLevelLabel>
            // TODO 앱 배포 후 해제
            )} */}
          {/* <ArrowLinkButton
            typographyProps={{
              sx: {
                color: SFPalette.grey2,
              },
            }}
            onClick={() => {
              toast.error('준비 중 입니다.');
            }}
          >
            본인 인증하기
          </ArrowLinkButton> */}
        </Box>
      </Box>
    </Container>
  );
}
